import { render, staticRenderFns } from "./CreateSalesManager.vue?vue&type=template&id=66a88088&"
import script from "./CreateSalesManager.vue?vue&type=script&lang=js&"
export * from "./CreateSalesManager.vue?vue&type=script&lang=js&"
import style0 from "./CreateSalesManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports